import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../../_actions/matchesActions";
import UserWidgetContainer from "../UserWidgetContainer";
import Section from "../../UI/Section";
import InfiniteScroll from "react-infinite-scroller";
import getShortlisted from "../../../_selectors/matchesSelectors/getShortlisted";
import getFavorite from "../../../_selectors/matchesSelectors/getFavorite";
import getMatchesLastResult from "../../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../../_utils";
import matchesConstants from "../../../_constants/matchesConstants";
import HoverWidget from "../../UI/HoverWidget";
class Favorite extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getFavorite } = this.props;
    updateHeader({
      title: "Favorited Members",
      description: "Members that you favorited"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Matches", link: "/matches" },
      { label: "Favorited Members", link: "/search" }
    ]);
    getFavorite();
  }
  componentWillUnmount() {
    const { clearMembers, clearFavorite } = this.props;
    clearMembers();
    clearFavorite();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section white={results.length === 0}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you favorited"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getFavorite(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getFavorite: () => dispatch(matchesActions.getFavoriteMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearFavorite: () => dispatch(matchesActions.clearFavoriteMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_FAVORITE_MEMBERS })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Favorite);



// WEBPACK FOOTER //
// ./src/_components/Matches/Favorite/index.js